<div class="blocked">
  <p> {{'Blocked.message'|translate}} </p>
  <button id="accept-button" (click)="onOkClick()"> OK </button>
</div>
